import Api from './index';

const getProductConfigs = params => Api.get('users/me/product-configs', { params });

const getProductConfig = productCurriculumId =>
  Api.get(`users/me/product-configs/${productCurriculumId}`);

const updateProductConfig = (productCurriculumId, data) =>
  Api.put(`users/me/product-configs/${productCurriculumId}`, { data });

export { getProductConfigs, getProductConfig, updateProductConfig };
